import { buildSerializer, buildDeserializer } from "lib/serializerUtils";

const serializeMap = {
  agencies: "agencies",
  channels: "channels",
  dateJoined: "date_joined",
  defaultRole: "default_role",
  deployments: "deployments",
  deploymentIds: "deployment_ids",
  email: "email",
  emailConfirmed: "email_confirmed",
  firstName: "first_name",
  groupIds: "group_ids",
  id: "id",
  invitationSentDate: "invitation_sent_date",
  isActive: "is_active",
  lastName: "last_name",
  name: "name",
  nlisAgentCredentials: "nlis_agent_credentials",
  nlisSaleyardCredentials: "nlis_saleyard_credentials",
  phoneNumber: "phone_number",
  reportFavourites: "report_favourites",
  receiveConsignedToEmailsFrom: "receive_consigned_to_emails_from",
  roleInvitationAcceptedDate: "role_invitation_accepted_date",
  roleInvitationSentDate: "role_invitation_sent_date",
  saleyards: "saleyards",
  slug: "slug",
  type: "type",
  userLevelId: "user_level_id",
  username: "username",
};

export const serializeLivestockAgent = buildSerializer(
  serializeMap,
  "livestockAgent",
);
export const deserializeLivestockAgent = buildDeserializer(
  serializeMap,
  "livestockAgent",
);
